module.exports = __webpack_public_path__ + "assets/46b75b23dcf09e1a44fd935641f88311.mp3";